import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/lib/ProtectedRoute";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AdminUpload from "@/pages/AdminUpload";
import EditorList from "@/pages/EditorList";
import EditorEdit from "@/pages/EditorEdit";
import VideoEditor from "@/pages/VideoEditor";
import MusicLibrary from "@/pages/MusicLibrary";
import VideoPage from "@/pages/VideoPage";
import NotFound from "@/pages/NotFound";

// Data router (createBrowserRouter) is required so `useBlocker` inside
// AdminUpload.jsx can intercept SPA navigation during active uploads.
// Legacy <BrowserRouter> + <Routes> does not support useBlocker.
export default function App() {
  const router = useMemo(
    () =>
      createBrowserRouter([
        { path: "/", element: <Login /> },
        { path: "/login", element: <Login /> },
        {
          path: "/admin",
          element: (
            <ProtectedRoute role="admin">
              <Admin />
            </ProtectedRoute>
          ),
        },
        {
          path: "/admin/upload",
          element: (
            <ProtectedRoute role="admin">
              <AdminUpload />
            </ProtectedRoute>
          ),
        },
        {
          path: "/admin/editor",
          element: (
            <ProtectedRoute role="admin">
              <EditorList />
            </ProtectedRoute>
          ),
        },
        {
          path: "/admin/editor/:id",
          element: (
            <ProtectedRoute role="admin">
              <EditorEdit />
            </ProtectedRoute>
          ),
        },
        {
          path: "/admin/edit/:slug",
          element: (
            <ProtectedRoute role="admin">
              <VideoEditor />
            </ProtectedRoute>
          ),
        },
        {
          path: "/admin/music",
          element: (
            <ProtectedRoute role="admin">
              <MusicLibrary />
            </ProtectedRoute>
          ),
        },
        { path: "/v/:slug", element: <VideoPage /> },
        { path: "*", element: <NotFound /> },
      ]),
    [],
  );

  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#17171a",
            border: "1px solid #2a2a30",
            color: "#f5f5f7",
          },
        }}
      />
    </AuthProvider>
  );
}
